import { Checkbox, Col, Row } from "@ezviz/ezd";
import React, { useState } from "react";
import "../index.less";

const ExperiencingProducts = ({ onChange = ()=>{}, value = {} }) => {
  const [accessValues, setAccessValues] = useState([]);
  const [pullCurrentValues, setPullCurrentValues] = useState([]);
  const [messageValues, setMessageValues] = useState([]);
  const [storageValues, setStorageValues] = useState([]);
  const [aiValues, setAiValues] = useState([]);
  const [otherValue, setOtherValue] = useState("");

  const triggerChange = (changedValue) => {
    onChange({
      access: accessValues,
      pullCurrent: pullCurrentValues,
      message: messageValues,
      storage: storageValues,
      ai: aiValues,
      other: otherValue,
      ...value,
      ...changedValue,
    });
  };

  return (
    <div className="container">
      <div>
        <div className="titleBlock">
          <div className="block" />
          <span className="title">接入</span>
        </div>
        <Checkbox.Group
          name="access"
          value={value.access || accessValues}
          onChange={(e) => {
            setAccessValues(e);
            triggerChange({ access: e });
          }}
        >
          <Row gutter={[15, 15]}>
            <Col span={8}>
              <Checkbox value="萤石设备接入">萤石设备接入</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="海康设备接入">海康设备接入</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="国标设备接入">国标设备接入</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="物联网卡">物联网卡</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div className="titleBlock">
          <div className="block" />
          <span className="title">拉流</span>
        </div>
        <Checkbox.Group
          name="pullCurrent"
          value={value.pullCurrent || pullCurrentValues}
          onChange={(e) => {
            setPullCurrentValues(e);
            triggerChange({ pullCurrent: e });
          }}
        >
          <Row gutter={[15, 15]}>
            <Col span={8}>
              <Checkbox value="直播大屏">直播大屏</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="web/h5拉流">web/h5拉流</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="app拉流">app拉流</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="视频客服">视频客服</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="语音广播">语音广播</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div className="titleBlock">
          <div className="block" />
          <span className="title">消息</span>
        </div>
        <Checkbox.Group
          name="message"
          value={value.message || messageValues}
          onChange={(e) => {
            setMessageValues(e);
            triggerChange({ message: e });
          }}
        >
          <Row gutter={[15, 15]}>
            <Col span={8}>
              <Checkbox value="消息告警">消息告警</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div className="titleBlock">
          <div className="block" />
          <span className="title">存储</span>
        </div>
        <Checkbox.Group
          name="storage"
          value={value.storage || storageValues}
          onChange={(e) => {
            setStorageValues(e);
            triggerChange({ storage: e });
          }}
        >
          <Row gutter={[15, 15]}>
            <Col span={8}>
              <Checkbox value="抓拍">抓拍</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="事件存储">事件存储</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="视频存储">视频存储</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="图片存储">图片存储</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div className="titleBlock">
          <div className="block" />
          <span className="title">AI</span>
        </div>
        <Checkbox.Group
          name="ai"
          value={value.ai || aiValues}
          onChange={(e) => {
            setAiValues(e);
            triggerChange({ ai: e });
          }}
        >
          <Row gutter={[15, 15]}>
            <Col span={8}>
              <Checkbox value="数字人">数字人</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="人证核验">人证核验</Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox value="离岗检测">离岗检测</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div className="titleBlock">
          <div className="block" />
          <span className="title">其他</span>
        </div>
        <div>
          <input
            className="customInput"
            style={{
              borderColor: "#D9D9D9",
            }}
            maxLength={500}
            value={value.other || otherValue}
            onChange={(e) => {
              setOtherValue(e.target.value);
              triggerChange({ other: e.target.value });
            }}
            placeholder="请输入其他需求"
          />
        </div>
      </div>
    </div>
  );
};

export default ExperiencingProducts;
